import { render, staticRenderFns } from "./OpenAccountContract.vue?vue&type=template&id=1ff49c82&scoped=true"
import script from "./OpenAccountContract.vue?vue&type=script&lang=js"
export * from "./OpenAccountContract.vue?vue&type=script&lang=js"
import style0 from "./OpenAccountContract.vue?vue&type=style&index=0&id=1ff49c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff49c82",
  null
  
)

export default component.exports